import { TimeTrackingTab } from '../const'
import { FilterValues } from '../types'

export interface InternalFilterState {
  status: string | null
  teamLeader: string | null
  teamMember: string | null
  customer: string | null
  order: string | null
  workPackage: string | null
}

export const deriveInitialFilterState = (
  initialFilters: FilterValues | undefined,
  teamLeaderIds: string[] = [],
): InternalFilterState => {
  const base: InternalFilterState = {
    status: null,
    teamLeader: null,
    teamMember: null,
    customer: initialFilters?.customer || null,
    order: initialFilters?.order || null,
    workPackage: initialFilters?.workPackage || null,
  }

  if (!initialFilters?.team) return base

  const isLeader =
    initialFilters.isTeamLeader ?? teamLeaderIds.includes(initialFilters.team)

  if (isLeader) return { ...base, teamLeader: initialFilters.team }

  return {
    ...base,
    teamMember: initialFilters.team,
    teamLeader: initialFilters.teamLeaderId || null,
  }
}

const CASCADES: Partial<
  Record<keyof InternalFilterState, (keyof InternalFilterState)[]>
> = {
  teamLeader: ['teamMember', 'customer', 'order', 'workPackage'],
  customer: ['order', 'workPackage'],
  order: ['workPackage'],
}

export const resetCascades = (
  state: InternalFilterState,
  key: keyof InternalFilterState,
  value: string | null,
): InternalFilterState => {
  const next: InternalFilterState = { ...state, [key]: value }
  for (const field of CASCADES[key] || []) next[field] = null
  return next
}

export const toFilterValues = (state: InternalFilterState): FilterValues => {
  const team = state.teamMember || state.teamLeader || null
  return {
    status: state.status,
    team,
    isTeamLeader: !state.teamMember && !!state.teamLeader,
    teamLeaderId:
      state.teamMember && state.teamLeader ? state.teamLeader : undefined,
    customer: state.customer,
    order: state.order,
    workPackage: state.workPackage,
  }
}

export const countActiveFilters = (
  state: InternalFilterState,
  currentTab: TimeTrackingTab,
): number => {
  const fields =
    currentTab === TimeTrackingTab.MY_TEAM
      ? [state.teamLeader]
      : [
          state.status,
          state.teamLeader,
          state.teamMember,
          state.customer,
          state.order,
          state.workPackage,
        ]
  return fields.filter((v) => v !== null).length
}
